module.exports = __webpack_public_path__ + "static/media/Lidl-logo.a84afe62.jpg";